import Vue from 'vue';
import Vuex from 'vuex';

import App from './App.vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import LocalStorage from 'vue-localstorage';
import { router } from './router/index';
import { store } from './store/index';
import ElementUI from 'element-ui';
import "./assets/element-ui-override.scss";

// import locale from 'element-ui/lib/locale/lang/ru-RU.js';
import VueI18n from 'vue-i18n'
// import i18n from './i18n'
import i18n from "@/locales";

Vue.use(VueI18n)
Vue.use(Vuex);

// Vue.use(ElementUI, { locale });
Vue.use(VueAxios, axios);
Vue.use(LocalStorage);
Vue.use(require('vue-shortkey'))
// Vue.use(require('moment'));
Vue.config.productionTip = false;

Vue.use(ElementUI, {
    size: "medium",
    i18n: (key, value) => i18n.t(key, value)
  });
  
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
}).$mount('#app');
